import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import User from './views/User.vue'
import UserDetail from './views/UserDetail.vue'
import { Auth } from 'aws-amplify'
import store from './store'

// UserDetail Components
import UserHome from './components/UserHome.vue'
import ATWorksheet from './components/ATWorksheet.vue'
import SMWorksheet from './components/SMWorksheet.vue'
import BAWorksheet from './components/BAWorksheet.vue'
import PSWorksheet from './components/PSWorksheet.vue'
import CRWorksheet from './components/CRWorksheet.vue'
import BIWorksheet from './components/BIWorksheet.vue'
import Lesson from './components/Lesson.vue'
import Access from './components/Access.vue'
import SelfCheck from './components/SelfCheck.vue'
import Authentication from './provider/authentication'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/user/:userId/:username/',
      component: UserDetail,
      children: [
        { path: 'detail', name: 'UserDetail', component: UserHome },
        { path: 'SMWorksheet', component: SMWorksheet },
        { path: 'ATWorksheet', component: ATWorksheet },
        { path: 'PSWorksheet', component: PSWorksheet },
        { path: 'CRWorksheet', component: CRWorksheet },
        { path: 'BAWorksheet', component: BAWorksheet },
        { path: 'BIWorksheet', component: BIWorksheet },
        { path: 'access', component: Access },
        { path: 'lesson', component: Lesson },
        { path: 'selfcheck', component: SelfCheck },
        { path: '*', component: UserHome }
      ]
    }
  ]
})

router.beforeResolve(async (to, from, next) => {
  let user
  // アプリ開始時にはfrom.nameにnullが格納されている（Nameが未定義の場合はundefined）
  if (from.name === null) {
    console.log('router - clear cache')
    user = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch(e => {
      console.log('not authenticated')
    })
  } else {
    user = await Auth.currentAuthenticatedUser().catch(e => {
      console.log('not authenticated')
    })
  }
  if (!user) {
    if (to.path !== '/') {
      console.log('not logined')
      return next('/')
    }
    return next()
  }
  await Authentication.auth(user).catch(async (e) => {
    console.log(e)
    console.log('router - invalid admin user')
    await Auth.signOut()
    if (to.path !== '/') {
      return next('/')
    }
    return next()
  })
  console.log('router - path:', to.path)
  console.log('isManger: ', store.getters.isManager)
  if (!store.getters.isManager) {
    return next()
  }
  if (to.path === '/') {
    console.log('already logined')
    return next('/user')
  } else {
    console.log('other')
    return next()
  }
})

export default router
